var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { cn } from '../../lib/utils.js';
import { CardAction, CardContent, CardDescription, CardFooter, CardHeader, Card as CardPrimitive, CardTitle, } from './primitives/card';
function CustomCard(_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    // Default card uses `overflow-hidden` to clip images that bleed to the card edges, so rounded
    // corners are respected without needing border-radius on every image. But this causes
    // search-select menus from being cut off when they overflow the card.
    // Any card that actually needs clipping (edge-to-edge images) can opt back in with
    // className="overflow-hidden"
    return <CardPrimitive className={cn('overflow-visible', className)} {...props}/>;
}
export { CustomCard as Card, CardAction, CardContent, CardDescription, CardFooter, CardHeader, CardTitle, };
